angular.module('TetherApp').factory('accessCodeService', [
    '$http',
    'Upload',
    function(
        $http,
        Upload
    ) {
        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let create = function (accessCode) {
            return $http.post(
                '/api/v1/access-code',
                accessCode,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let update = function (accessCode) {
            return $http.post(
                '/api/v1/access-code/' . accessCode.id,
                accessCode,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let upload = function ($file, accessCodeList) {
            return Upload.upload({
                url: '/api/v1/access-code/upload',
                data: {
                    file: $file,
                    accessCodeListId: accessCodeList.id
                }
            }).then(
                function (resp) {
                    return resp;
                },
                function (resp) {
                    return resp;
                }
            );
        };

        return {
            create: create,
            update: update,
            upload: upload
        }
    }
]);
